<template>
  <div id="app" class="container">
    <div v-if="needsSidebar()">
      <div class="d-flex justify-content-center mt-3">
        <img class="app-logo" src="./assets/image/BisericaBaptistaSperanta-Logo.png" alt="Biserica Baptista Speranta">
      </div>      
      <b-nav class="my-4 d-flex justify-content-center container-menu">
        <b-nav-item :to="{ name: 'Dashboard'}" class="dashboard" v-on:click="changeSelected">Dashboard</b-nav-item>
        <!-- <b-nav-item :to="{ name: 'UserList' }" class="user" v-on:click="changeSelected">User</b-nav-item> -->
        <b-nav-item :to="{ name: 'AudioList' }" class="audio" v-on:click="changeSelected">Audio</b-nav-item>
        <b-nav-item :to="{ name: 'VideoList' }" class="video" v-on:click="changeSelected">Video</b-nav-item>
        <b-nav-item :to="{ name: 'TestimonialList' }" class="testimonial" v-on:click="changeSelected">Testimonial</b-nav-item>
        <b-nav-item :to="{ name: 'SpeakerList' }" class="speaker" v-on:click="changeSelected">Speaker</b-nav-item>
        <b-nav-item :to="{ name: 'InfoList' }" class="info" v-on:click="changeSelected">Info</b-nav-item>
        <!-- <b-nav-item :to="{ name: 'MediaObjectList' }" class="mediaobject" v-on:click="changeSelected">MediaObject</b-nav-item> -->
        <b-nav-item v-on:click="logout"><i class="fas fa-sign-out-alt"></i>
            Logout</b-nav-item>
      </b-nav>   
      <div class="container-router my-3">
        <router-view></router-view>
      </div>
    </div> 
    <div v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    }
  },
  mounted() {
    // Remove active from dashboard
    this.clearDashboardActive();
  },
  methods: {
   needsSidebar: function() {   
      let isAutentificated =  this.$store.getters["auth/isAuthenticated"];
      if(isAutentificated) {
        return true;
      } else {
        return false;
      }
    },
    logout: function() {
      this.$store.dispatch("auth/authLogout").then(() => {
        this.$router.push("/login");         
      });
    },
    changeSelected() {
      // Remove active from dashboard 
      this.clearDashboardActive();
    },
    clearDashboardActive() {      
      let routerPath = this.$router.currentRoute.path;
      if (routerPath != '/' && routerPath != '/login') {          
          document.getElementsByClassName("dashboard")[0].firstChild.classList.remove("router-link-active"); 
      } 
    }  
  }
}
</script>
<style lang="scss">
  @import 'node_modules/bootstrap/scss/bootstrap';
  @import 'node_modules/bootstrap-vue/src/index.scss';

  #app {  
    .container-menu {
      background-color: #fff;      
      padding: 10px;            
      box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);

      .nav-item:hover {
        background-color: #007bff;
        color: #fff;
        a:hover{
          color: #fff;
          text-decoration: none;
        }
      }
      .router-link-active {
        background-color: #007bff;
        color: #fff;   
      }      
    }  
    .container-router {
      background-color: #fff;
      min-height: auto;
      padding: 20px;      
      box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);
    }
    .app-logo {     
      max-width: 300px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/App.vue